import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {Avatar} from "@irati/ui/src/Typography"

const DEFAULT_SIZE = 50

export const Pic = styled.div`
  ${({size}) =>
    size &&
    `
    width: ${size}px;
    height: ${size}px;
  `}
  background-color: ${({theme}) => theme.colors.utility.highlight};
  border-radius: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: default;
`

const Plus = (props) => {
  const {count, size, className} = props
  const idNamespace = id("default-profile-picture", props)
  return (
    <Pic id={idNamespace} size={size} className={className}>
      <Avatar id={id("title", idNamespace)} regular>
        +{count}
      </Avatar>
    </Pic>
  )
}

Plus.propTypes = {
  count: PropTypes.number,
  size: PropTypes.number,
  className: PropTypes.string
}

Plus.defaultProps = {
  count: null,
  size: DEFAULT_SIZE,
  className: null
}

export default Plus
